import styled from "styled-components";

export default styled.span`
    color: var(--red);
    font-size: 0.8rem;
`;
